require('./contractAsnefError.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
// @ utilities
const { formatText } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');
// @ commons
const WizardError = require('components/commons/wizardError/wizardError');
// @constants
const { EURO_SYMBOL } = require('constants/index');

class ContractAsnefError extends React.Component {
    constructor(props) {
        super(props);
        this.handleDocumentationClick =
            this.handleDocumentationClick.bind(this);
    }

    handleDocumentationClick(e) {
        e.preventDefault();
        this.props.history.push('/myprofile/documentation');
    }

    handleTextWithCustomLinks() {
    const { errorValue } = this.props;
    const value = { amount: errorValue, currency: EURO_SYMBOL };
    const valueString = getFormattedString(value);

    const originalText = formatText("contractsView-asnefErrorText2", [
        valueString,
    ]);

    const documentationText = formatText("breadcumb-documentation", [
        valueString,
    ]);

    const parts = originalText.split(/(<a[^>]*>.*?<\/a>)/g);

    return parts.map((part, index) => {
        if (part.includes('href="/myprofile/documentation"')) {
            const linkMatch = part.match(/>([^<]+)</);
            const linkText = linkMatch && linkMatch[1] ? linkMatch[1] : documentationText;

            return (
                <a
                    key={index}
                    href="/myprofile/documentation"
                    onClick={this.handleDocumentationClick}
                    style={{
                        cursor: "pointer",
                    }}
                >
                    {linkText}
                </a>
            );
        }
        return (
            <span key={index} dangerouslySetInnerHTML={{ __html: part }} />
        );
    });
}

    render() {
        const title = formatText('contractsView-asnefErrorText1');
        const goBackLink = {
            label: formatText(
                'contractEasyLoanError-goBackLinkText'
            ).toUpperCase(),
            url: 'myprofile/global',
        };

        return (
            <section className="col-xs-12 contract-asnef-error">
                <WizardError errorMessage={title} mainButton={goBackLink}>
                    <div className="contract-asnef-error__content">
                        <div className="contract-asnef-error__text">
                            {this.handleTextWithCustomLinks()}
                        </div>
                    </div>
                </WizardError>
            </section>
        );
    }
}

ContractAsnefError.propTypes = {
    errorValue: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(ContractAsnefError);
